import React from 'react';

class FreeForm extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'FreeForm';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const className = 'component-free-form ' + this.props.iteration + '-' +
    data.id + ' prev-section-type-' + this.props.prevSectionType;

    return (
      <section
        className={className}
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - The element data
 * @prop {Number} iteration - The iteration of the element
 * @prop {String} prevSectionType - The type of the previous section
 */
FreeForm.propTypes = {
  data: React.PropTypes.object,
  iteration: React.PropTypes.number,
  prevSectionType: React.PropTypes.string,
};


export default FreeForm;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/FreeForm.jsx
 **/